import { computed } from 'mobx';
import { isFeatureEnabled } from 'owa-feature-flags';
import uniqBy from 'lodash-es/uniqBy';
import RibbonButton from '../components/buttons/RibbonButton';
import formatPainter from '../components/buttons/formatPainter';
import fontName from '../components/buttons/fontName';
import fontSize from '../components/buttons/fontSize';
import bold from '../components/buttons/bold';
import italic from '../components/buttons/italic';
import underline from '../components/buttons/underline';
import backColor from '../components/buttons/backColor';
import textColor from '../components/buttons/textColor';
import bullets from '../components/buttons/bullets';
import numbering from '../components/buttons/numbering';
import indent from '../components/buttons/indent';
import outdent from '../components/buttons/outdent';
import blockquote from '../components/buttons/blockquote';
import alignLeft from '../components/buttons/alignLeft';
import alignCenter from '../components/buttons/alignCenter';
import alignRight from '../components/buttons/alignRight';
import insertLink from '../components/buttons/insertLink';
import unlink from '../components/buttons/unlink';
import superscript from '../components/buttons/superscript';
import subscript from '../components/buttons/subscript';
import strikethrough from '../components/buttons/strikethrough';
import imageAltText from '../components/buttons/imageAltText';
import ltr from '../components/buttons/ltr';
import rtl from '../components/buttons/rtl';
import undo from '../components/buttons/undo';
import redo from '../components/buttons/redo';
import removeFormat from '../components/buttons/removeFormat';
import insertTable from '../components/buttons/insertTable';

const computedButtons = computed(function getComputedButtons(): RibbonButton[] {
    const buttons = [
        formatPainter,
        isFeatureEnabled('cmp-ribbonRemoveFormatAtFront') ? removeFormat : null,
        fontName,
        fontSize,
        bold,
        italic,
        underline,
        isFeatureEnabled('cmp-ribbonBIUS') ? strikethrough : null,
        backColor,
        textColor,
        bullets,
        numbering,
        outdent,
        indent,
        blockquote,
        alignLeft,
        alignCenter,
        alignRight,
        insertLink,
        unlink,
        superscript,
        subscript,
        strikethrough,
        imageAltText,
        ltr,
        rtl,
        undo,
        redo,
        removeFormat,
        insertTable,
    ];
    // remove duplicates favoring the first entry
    const filteredButtons = buttons.filter(
        button => button != null && (!button.isHidden || !button.isHidden())
    );
    return uniqBy(filteredButtons, button => button.key);
});

export default function getButtons(): RibbonButton[] {
    return computedButtons.get();
}
